// Bootstrap: portão de autenticação, depois o shell.
//
// A ordem importa. A sessão precisa estar carregada antes do shell montar,
// porque o NAV é filtrado por permissão — sem isso, o menu pisca com itens que
// o usuário não pode abrir. As settings carregam em paralelo: os getters têm
// fallback, então a primeira renderização não espera o banco.

import './styles/tokens.css';
import './styles/base.css';

import { carregarSessao } from './lib/permissions';
import { loadSettings } from './lib/settings';
import { getSupabase } from './lib/supabase';
import { montarShell } from './layout/shell';
import { mostrarAguardandoAprovacao, mostrarLogin } from './features/auth/index';
import { env } from './lib/env';

console.info('[CD Painel] build', env.buildId);

async function iniciar(): Promise<void> {
  const sessao = await carregarSessao();

  if (!sessao) {
    mostrarLogin();
    return;
  }

  if (!sessao.ativo) {
    mostrarAguardandoAprovacao(sessao);
    return;
  }

  await loadSettings();

  const app = document.getElementById('app');
  if (app) app.innerHTML = '';
  montarShell();
}

// Login por OAuth volta com a sessão nova; re-inicia para pegar os claims.
getSupabase().auth.onAuthStateChange((evento) => {
  if (evento === 'SIGNED_IN' || evento === 'SIGNED_OUT') {
    void iniciar();
  }
});

void iniciar().catch((err) => {
  console.error('[CD Painel] falha no boot', err);
  const app = document.getElementById('app');
  if (app) {
    app.innerHTML = `
      <div class="auth">
        <div class="auth-cartao">
          <h1 class="auth-titulo">Não foi possível iniciar</h1>
          <p class="auth-texto">${err instanceof Error ? err.message : 'Erro desconhecido.'}</p>
        </div>
      </div>`;
  }
});
